module.exports = __webpack_public_path__ + "static/media/vancouer.1f7a9196.png";